var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "comission-counter" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("span", { staticClass: "profile-title" }, [_vm._v("Consumidor: ")]),
        _vm._v(
          "\n    " +
            _vm._s(_vm.getQuantityItemInList(_vm.commissionConsumerList)) +
            " | R$\n    "
        ),
        _c("RenderMoneyColumnValue", {
          attrs: {
            value: _vm.sumColumn("comissionCalc", _vm.commissionConsumerList)
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("span", { staticClass: "profile-title" }, [_vm._v("Promotor")]),
        _vm._v(
          "\n    " +
            _vm._s(_vm.getQuantityItemInList(_vm.commissionTraderList)) +
            " | R$\n    "
        ),
        _c("RenderMoneyColumnValue", {
          attrs: {
            value: _vm.sumColumn("comissionCalc", _vm.commissionTraderList)
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("span", { staticClass: "profile-title" }, [_vm._v("Investidor")]),
        _vm._v(
          "\n    " +
            _vm._s(_vm.getQuantityItemInList(_vm.commissionInvestorList)) +
            " | R$\n    "
        ),
        _c("RenderMoneyColumnValue", {
          attrs: {
            value: _vm.sumColumn("comissionCalc", _vm.commissionInvestorList)
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }